module.exports = __webpack_public_path__ + "img/gift14.d18d5e8f.png";